import { Component } from '@angular/core';

@Component({
  selector: 'ui-modal-footer',
  templateUrl: './modal-footer.component.html'
})
export class ModalFooterComponent {
}